import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    background: '#F2F1F1',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    overflowX: 'hidden',
  },
  rootForm: {
    display: 'flex',
    flexDirection: 'column',
    width: '78%',
    marginTop: '31vh',
    marginLeft: '19%',
    marginBottom: '3%',
    maxHeight: '57vh !important',
    overflowX: 'hidden',
  },
  inputText: {
    textTransform: 'uppercase',
    /* '&:invalid': {
      background: 'url("https://assets.digitalocean.com/labs/icons/exclamation-triangle-fill.svg") no-repeat 95% 50% lightsalmon',
      backgroundSize: '25px',
      color: '#000'
    } */
  },
  inputEmail: {
    textTransform: 'lowercase',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
  },
  large: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#FFF',
    marginBottom: '2%',
    color: '#949494',
  },
  input2: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '38px',
    textTransform: 'uppercase',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '10px',
    fontSize: '16px',
    opacity: '100%',
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '99%',
    backgroundColor: '#FFF',
    marginBottom: '2%',
    borderRadius: '4px',
  },
  medium: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '97%',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  small: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '47%',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  input: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '44px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '1%',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
    backgroundColor: '#ebe7e7',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'right',
    alignItems: 'flex-end',
  },
  itemSmall: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'right',
    alignItems: 'flex-start',
  },
  button: {
    width: '16%',
    backgroundColor: '#026894',
    color: '#FFF',
    paddingTop: '2px',
    paddingBottom: '2px',
    height: '47px',
    boxShadow: 'none',
    border: 'none',
    textTransform: 'capitalize',
    fontSize: '16px',
  },
  summary: {
    backgroundColor: '#C4C4C4',
    borderRadius: '5px',
  },
  details: {
    backgroundColor: '#ECECEC',
  },
  grid: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  grid2: {
    display: 'block',
  },
  divButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '3%',
  },
  selectBox: {
    float: 'left',
    width: '97%',
    color: '#6161ff',
    backgroundColor: '#fff',
    textDecoration: 'underline',
    height: '43px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '15px',
    borderRadius: '5px',
    cursor: 'pointer',
    borderWidth: 0,
  },
  label: {
    fontSize: '13px',
    fontWeight: 'bold',
    float: 'left',
    marginBottom: '7px',
    width: '97%',
  },
}));

export default useStyles;
